/* Only hide the dock for a real editable field; no scroll-driven animation. */
(() => {
  const mobile = window.matchMedia('(max-width: 767px)');
  // A shared filtered URL must not leave mobile customers with hidden filters.
  function resetHiddenFilters() {
    if (!mobile.matches || !document.body.classList.contains('template-collection')) return;
    const url = new URL(window.location.href);
    const obsolete = [...url.searchParams.keys()].filter((key) => key.startsWith('filter.') || key === 'sort_by');
    if (!obsolete.length) return;
    obsolete.forEach((key) => url.searchParams.delete(key));
    url.searchParams.delete('page');
    window.location.replace(url.href);
  }
  resetHiddenFilters();
  mobile.addEventListener('change', resetHiddenFilters);
  // The mobile menu has its own markup: put the catalog before informational links.
  const menu = document.querySelector('[data-mobile-menu]');
  const shopLink = document.querySelector('.mobile-dock__shop');
  if (menu && shopLink) {
    const catalogLink = [...menu.querySelectorAll('a')].find((link) => link.pathname === shopLink.pathname);
    if (catalogLink) catalogLink.parentElement.prepend(catalogLink);
  }
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.solutions [data-add-to-setup]');
    if (!mobile.matches || !trigger || trigger.getAttribute('aria-pressed') !== 'true') return;
    const setup = trigger.closest('[data-protection-config-scope]')?.querySelector('[data-protection-config]');
    if (!setup) return;
    setup.open = true;
    setup.querySelector('[data-config-tab][aria-selected="true"]')?.focus({ preventScroll: true });
    setup.scrollIntoView({ block: 'start', behavior: 'auto' });
  });
  function update() {
    const field = document.activeElement;
    const editing = field && field.matches('textarea, [contenteditable="true"], input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="range"]):not([type="hidden"])');
    document.body.classList.toggle('mobile-keyboard-open', mobile.matches && !!editing);
  }
  document.addEventListener('focusin', update);
  document.addEventListener('focusout', () => requestAnimationFrame(update));
  mobile.addEventListener('change', update);
})();
